export class CenterLite {

    private centerImage: string;
    private centerName: string;
    private internalId: string;
    private userRoleInCenter: string[];

    constructor(centerImage?: string, ceterName?: string, internalId?: string, userRoleInCenter?: string) {
    }

    public get CenterImage() {
        return this.centerImage;
    }
    public get CenterName() {
        return this.centerName;
    }
    public get InternalId() {
        return this.internalId;
    }
    public get UserRoleInCenter() {
        return this.userRoleInCenter;
    }
    public set CenterImage(centerImage) {
        this.centerImage = centerImage;
    }
    public set CenterName(centerName) {
        this.centerName = centerName;
    }
    public set InternalId(internalId) {
        this.internalId = internalId;
    }
    public set UserRoleInCenter(userRoleInCenter) {
        this.userRoleInCenter = userRoleInCenter;
    }
}
